module.exports = __webpack_public_path__ + "img/15.4c58b211.png";